<div class="payment-modal">
    <div class="modal-header">
        <h2 mat-dialog-title>Complete Payment</h2>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="modal-content">
        <form [formGroup]="paymentForm" class="payment-form">
            <!-- Application Info -->
            <div class="application-info mb-6">
                <div class="info-card">
                    <h3 class="text-lg font-medium mb-2">Application Details</h3>
                    <!-- <div class="info-item">
                        <span class="label">Application ID:</span>
                        <span class="value">{{ data.applicationId }}</span>
                    </div> -->
                    <div class="info-item" *ngIf="data.businessName">
                        <span class="label">Business Name:</span>
                        <span class="value">{{ data.businessName }}</span>
                    </div>
                </div>
            </div>

            <!-- Year Selection -->
            <div class="year-selection mb-6">
                <!-- <div class="text-base mb-2 font-medium">Select Membership Duration</div> -->
                <div class="text-base mb-2 font-medium">Membership Years</div>
                <mat-form-field appearance="outline" class="w-[1/2]">
                    <mat-select formControlName="numberOfSubscriptionYear" (selectionChange)="onYearChange()" placeholder="Select Year(s)">
                        <mat-option value="1">1 year</mat-option>
                        <mat-option value="3">3 years</mat-option>
                    </mat-select>
                    <mat-error *ngIf="paymentForm.get('numberOfSubscriptionYear')?.hasError('required')">
                        Year is required
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Fee Calculation and Coupon Section -->
            <div *ngIf="computedPrice !== null" class="fee-section">
                <!-- Coupon and Price Container -->
                <div class="coupon-price-container">
                    <!-- Coupon Input Section -->
                    <div class="coupon-section" *ngIf="!data.exemptedEmb?.active">
                        <div class="text-base mb-2 font-medium">Discount Coupon (Optional)</div>
                        <div class="coupon-input-container">
                            <mat-form-field appearance="outline" class="coupon-field" [ngClass]="{'applied-coupon': !!appliedCoupon}">
                                <input matInput 
                                       [formControl]="couponCodeControl"
                                       [placeholder]="appliedCoupon ? 'Coupon applied' : 'Enter coupon code'"
                                       (input)="clearCouponValidation()">
                                <mat-icon matSuffix *ngIf="appliedCoupon">check_circle</mat-icon>
                                <mat-error *ngIf="couponError">{{ couponError }}</mat-error>
                            </mat-form-field>
                            <button mat-raised-button 
                                    class="mat-blue apply-coupon-btn !rounded-[50px]"
                                    *ngIf="!appliedCoupon"
                                    (click)="validateCoupon()" 
                                    [disabled]="!couponCodeControl.value || validatingCoupon">
                                <div class="button-content">
                                  <span>{{ validatingCoupon ? 'Applying...' : 'Apply' }}</span>
                                  <mat-spinner *ngIf="validatingCoupon" diameter="20" color="accent"></mat-spinner>
                                </div>
                            </button>
                            <button mat-stroked-button 
                                    color="warn"
                                    class="remove-coupon-btn"
                                    *ngIf="appliedCoupon"
                                    (click)="removeCoupon()">
                                <mat-icon>close</mat-icon>
                                Remove Coupon
                            </button>
                        </div>
                        
                        <!-- Coupon Error Message -->
                        <div class="coupon-error" *ngIf="couponError && !appliedCoupon">
                            <mat-icon color="warn">error</mat-icon>
                            <span>{{ couponError }}</span>
                        </div>
                        
                        <!-- Coupon Success Message -->
                        <div class="coupon-success" *ngIf="appliedCoupon">
                            <mat-icon color="primary">check_circle</mat-icon>
                            <span>Coupon "{{ appliedCoupon.couponName }}" applied! {{ appliedCoupon.discountPercentage }}% discount</span>
                        </div>
                    </div>

                    <!-- Price Display Section -->
                    <div class="price-display-section">
                        <div 
                            [matTooltip]="data.exemptedEmb?.active ? 'Exempted' : ''" 
                            [ngClass]="{'exempted-fee': data.exemptedEmb?.active}">
                            
                            <!-- With Applied Coupon -->
                            <div *ngIf="appliedCoupon && originalPrice" class="price-breakdown">
                                <div class="price-line">
                                    <span class="price-label">Membership Fee:</span>
                                    <span class="original-price-striked">€{{ truncatePrice(originalPrice) }}</span>
                                </div>
                                <div class="price-line discount-line">
                                    <span class="discount-label">Discount ({{ appliedCoupon.discountPercentage }}%):</span>
                                    <span class="discount-amount">-€{{ truncatePrice(discountAmount) }}</span>
                                </div>
                                <div class="price-line final-price-line">
                                    <span class="price-label">Final Amount:</span>
                                    <span class="final-price">€{{ computedPrice !== null ? truncatePrice(computedPrice) : '0.00' }}</span>
                                </div>
                            </div>
                            
                            <!-- Without Coupon -->
                            <div *ngIf="!appliedCoupon" class="simple-price">
                                <span class="price-label">Membership Fee:</span>
                                <span class="price-amount">€{{ computedPrice !== null ? truncatePrice(computedPrice) : '0.00' }}</span>
                            </div>
                            
                            <p *ngIf="!data.exemptedEmb?.active" class="vat-note">(incl. VAT 21%)</p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions class="modal-actions">
        <button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
        <button mat-raised-button 
                class="mat-blue pay-now-btn !rounded-[50px]"
                (click)="proceedToPayment()"
                [disabled]="!paymentForm.valid || computedPrice === null || isProcessing">
            <div class="button-content" *ngIf="!isProcessing">
                <span>Pay €{{ computedPrice !== null ? truncatePrice(computedPrice) : '0.00' }}</span>
            </div>
            <div class="button-content" *ngIf="isProcessing">
                <span>Processing...</span>
                <mat-spinner diameter="20" color="accent"></mat-spinner>
            </div>
        </button>
    </mat-dialog-actions>
</div>
